unit f_trasporti;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  f_ordinedettaglio, DateUtils, f_selezione, w_edit, un_servermodule, w_label,
  un_telemetria, UnArrayDef, DB, un_user;

type

  TVisibilita = (visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso);
const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo gli ultimi 300 trasporti' ;
  msgDateErrate = 'Correggi le date corrette per visualizzare i trasporti';
  msgNessunRecord = 'Nessun trasporto da visualizzare';
  msgCaricamentoInCorso = 'Nessun trasporto da visualizzare...';
//  msgCaricamentoInCorso = 'Caricamento trasporti in corso...';

type
  { TFrmTrasporti }

  TFrmTrasporti = class(TWidget)
    procedure AfterRender; override;
  private
    whereDate :String;
    dt1str, dt2str :String;
    function DateOk:Boolean;
    procedure RefreshTrasporti; async;
    procedure QryTrasportiOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita:TVisibilita);
    procedure SetLabelStampa;
    procedure SetLabelStampa2;
  published
    procedure tab1_rowclick; async;
    procedure filtro_change;
    procedure filtro_input;
    procedure impostadate;
    procedure fltuttitrasporti_click; async;
    procedure data1_change;
    procedure data2_change;
    procedure stampa1_click(event: TJSEvent); async;
    stampa1 :TJSHTMLButtonElement;
    procedure stampa2_click(event: TJSEvent); async;
    stampa2 :TJSHTMLButtonElement;
    procedure idriepilogo_click; async;
//    procedure link3_click(event: TJSEvent); async;
    data1 : TJSHTMLInputElement;
    data2 : TJSHTMLInputElement;
    filtro: TWEdit;
    edit2: TJSHTMLInputElement;
    idriepilogo: TJSHTMLInputElement;
    pnltab1: TJSHTMLElement;
//    link3: TJSHTMLAnchorElement;
    QryTrasporti: TQuery;
    tab1:TWTable;
    labelTop:TWLabel;
    labelBottom:TWLabel;
    fltuttitrasporti:TJSHTMLInputElement;
  end;

implementation

{$R *.html}

{ TFrmTrasporti }

procedure TFrmTrasporti.AfterRender;
begin

  QryTrasporti.OnFilterRecord := @QryTrasportiOnFilterRecord;

  filtro.placeholder := 'Ricerca trasporti...';
  filtro.seleziona1.Visible:= false;

  labelTop.header.innerHTML:= '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML:= '<br><br>';


  labelBottom.labelbody.innerHTML:= 'bottom';
  labelBottom.header.innerHTML:= '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';


//  data1.value := window.localStorage[ClassName+'_data1'] ;
//  data2.value := window.localStorage[ClassName+'_data2'] ;

  fltuttitrasporti.checked:=false;

  impostadate;

  RefreshTrasporti;

end;


procedure TFrmTrasporti.QryTrasportiOnFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
var
  str:String;
  i: Integer;
begin
  Accept:= true;
  str := filtro.value.ToLowerInvariant;
  for i:= 0 to DataSet.FieldCount-1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
         exit;
  end;
  //nessun campo matcha la stringa cercata
  Accept := false;
end;



procedure TFrmTrasporti.SetLabel(lbl:TWLabel;value:String);
begin
  lbl.Visible :=   value <> '' ;
  lbl.labelbody.innerHTML := value;
end;

procedure TFrmTrasporti.SetLabelStampa;
var
  RecordCount: Integer;
begin
  if not QryTrasporti.Active then
    exit;

  RecordCount := 0;
  QryTrasporti.First;
  while not QryTrasporti.EOF do
  begin
    Inc(RecordCount);
    QryTrasporti.Next;
  end;
  stampa1.innerHTML:= format('Trasporti (%d %s)'
      ,[RecordCount, IfThen(RecordCount = 1,'','') ]);
end;

procedure TFrmTrasporti.SetLabelStampa2;
var
  RecordCount: Integer;
begin
  if not QryTrasporti.Active then
    exit;

  RecordCount := 0;
  QryTrasporti.First;
  while not QryTrasporti.EOF do
  begin
    Inc(RecordCount);
    QryTrasporti.Next;
  end;
  stampa2.innerHTML:= format('ins.km. (%d %s)'
      ,[RecordCount, IfThen(RecordCount = 1,'km','') ]);

end;

procedure TFrmTrasporti.ImpostaVisibilita(visibilita: TVisibilita);
begin
  //visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso
  SetLabelStampa;
  SetLabelStampa2;
  SetLabel(labelTop,'');
  SetLabel(labelBottom,'');

  if visibilita = visDateErrate then SetLabel(labelTop,msgDateErrate);
  if visibilita = visNessunRecord then SetLabel(labelBottom,msgNessunRecord);
  if visibilita = visLimiteRecord then SetLabel(labelBottom,msgLimiteRecord);
  if visibilita = visCaricamentoInCorso then SetLabel(labelBottom,msgCaricamentoInCorso);

  filtro.Visible :=  visibilita <> visDateErrate;
//  console.log(format(' filtro.Visible := %s',[BoolToStr(filtro.Visible,true)]));
  pnltab1.Visible:= visibilita in [visLimiteRecord,visCiSonoRecord];
end;

procedure TFrmTrasporti.RefreshTrasporti;
begin

  if not DateOk then
  begin
    ImpostaVisibilita(visDateErrate);
    exit;
  end;
  ImpostaVisibilita(visCaricamentoInCorso);
  QryTrasporti.Close;
  QryTrasporti.SQL.Text:=  'select idviaggio as idv, idtrasporto, dtdata as data, horapartenza as orap, horaarrivo as entrole, '
                      + ' dsautista as autista, dsaccompagnatore as accomp, dsautomezzo as mezzo, '
                      + ' dstiporichiesta as rich, dsfruitore as partenza, dsindirizzopartenza as indpartenza, '
                      + ' dsfruitore2 as arrivo, dsindirizzoarrivo as indarrivo, dstelefono as telef, '
                      + ' dsnote as note, idviaggio '
                      + ' from ta_trasporti '
                      + ' where idsocieta = ''DON001'' '
                      + ' and ' + whereDate;
  if not fltuttitrasporti.checked then
  begin
    QryTrasporti.SQL.Text := QryTrasporti.SQL.Text
      + ' and (idautista = ' + user.QryUtenti.FieldByName('idanagrafica').AsString
      + ' or idaccompagnatore = ' + user.QryUtenti.FieldByName('idanagrafica').AsString + ')';
  end;
  QryTrasporti.SQL.Text := QryTrasporti.SQL.Text + ' order by dtdata, dsautista, horapartenza ';
  AWait(QryTrasporti.Open);

  console.log(format('QryTrasporti.RecordCount=%d',[QryTrasporti.RecordCount]));
  QryTrasporti.FieldByName('IDTRASPORTO').Visible:= false;
  QryTrasporti.FieldByName('IDVIAGGIO').Visible:= false;

  RefreshFiltro;
end;

procedure TFrmTrasporti.RefreshFiltro;
begin
  QryTrasporti.Filtered:= filtro.value.Trim <> '';
  QryTrasporti.First;
  tab1.RenderDataSet(QryTrasporti);

  if QryTrasporti.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if QryTrasporti.RecordCount = limiteRecord  then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);
end;

procedure TFrmTrasporti.filtro_change;
begin
  RefreshFiltro;
end;

procedure TFrmTrasporti.filtro_input;
begin
  RefreshFiltro;
end;

procedure TFrmTrasporti.impostadate;
var
//  Oggi, LunediProssimo: TDateTime;
begin
  //Oggi := Date;
  //
  //// Trova il lunedì della prossima settimana
  //LunediProssimo := Oggi + (DayOfTheWeek(Oggi)- 5);
  //
  //// Imposta i componenti (es. TDateEdit o TDateTimePicker)
  //data1.value := FormatDateTime('yyyy-mm-dd',LunediProssimo);          // Lunedì
  //data2.value  := FormatDateTime('yyyy-mm-dd',LunediProssimo + 10);      // Venerdì

  data1.value:=FormatDateTime('yyyy-mm-dd',Date);
  data2.value:=FormatDateTime('yyyy-mm-dd',Date + 15);
end;

procedure TFrmTrasporti.fltuttitrasporti_click;
begin
  Console.Log('parte');
  RefreshTrasporti;
end;

procedure TFrmTrasporti.tab1_rowclick;
var
  idV: Integer;
  dataV: TDateTime;
  giornoSett: Integer;
  nomeCampoGiorno: String;
  sqlDinamica: String;
  sDataSql: String;
begin
  // 1. Recupero l'ID Viaggio e la Data
  idV := QryTrasporti.FieldByName('idviaggio').AsInteger;
  dataV := QryTrasporti.FieldByName('data').AsDateTime;

  // Data nel formato SQL
  sDataSql := FormatDateTime('yyyy-mm-dd', dataV);

  // 2. Determiniamo il giorno
  // 1 = Domenica, 2 = Lunedì, ecc.
  giornoSett := DayOfWeek(dataV);

  // 3. Mappatura del campo giorno
  case giornoSett of
    1: nomeCampoGiorno := 'FLDOMENICA';
    2: nomeCampoGiorno := 'FLLUNEDI';
    3: nomeCampoGiorno := 'FLMARTEDI';
    4: nomeCampoGiorno := 'FLMERCOLEDI';
    5: nomeCampoGiorno := 'FLGIOVEDI';
    6: nomeCampoGiorno := 'FLVENERDI';
    7: nomeCampoGiorno := 'FLSABATO';
  end;

  // 4. Apertura form di selezione
  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;
      QrySeleziona.Close;

      {
        LOGICA:

        IDVIAGGIO 1:
          - persona presente nel campo del giorno con valore 1a o 1b
          - FRCdiurno deve essere X
          - non sospesa alla data del viaggio

        IDVIAGGIO 2:
          - persona presente nel campo del giorno con valore 2a o 2b
          - FRCdiurno deve essere X
          - non sospesa alla data del viaggio

        IDVIAGGIO 3:
          - persona presente nel campo del giorno con valore 3
          - FRASSPENSIONATI deve essere X
          - non sospesa alla data del viaggio

        IDVIAGGIO 4:
          - persona presente nel campo del giorno con valore 4
          - FRASSPENSIONATI deve essere X
          - non sospesa alla data del viaggio

        ALTRI IDVIAGGIO:
          - persona presente nel campo del giorno con il valore dell'IDVIAGGIO
          - non sospesa alla data del viaggio
      }

      if idV = 1 then
      begin
        sqlDinamica :=
            'SELECT ' + nomeCampoGiorno + ' AS IDV, '
          + ' DSRAGIONESOCIALE UTENTE, '
          + ' DSINDIRIZZO ||'' - ''|| DSLOCALITA ||'' - ''|| DSPROVINCIA AS INDIRIZZO, '
          + ' DSTELEFONO AS TELEFONO, DSNOTE AS NOTE '
          + ' FROM an_anagrafiche WHERE '
          + nomeCampoGiorno + ' IN (''1a'', ''1b'') '
          + ' AND FRCdiurno = ''X'' '
          + ' AND (DTSOSPESOFINOA IS NULL OR '
          + #39 + sDataSql + #39 + ' > DTSOSPESOFINOA) '
          + ' ORDER BY '
          + nomeCampoGiorno + ' ASC, '
          + ' IDORDINE ASC';
      end

      else if idV = 2 then
      begin
        sqlDinamica :=
            'SELECT ' + nomeCampoGiorno + ' AS IDV, '
          + ' DSRAGIONESOCIALE UTENTE, '
          + ' DSINDIRIZZO ||'' - ''|| DSLOCALITA ||'' - ''|| DSPROVINCIA AS INDIRIZZO, '
          + ' DSTELEFONO AS TELEFONO, DSNOTE AS NOTE '
          + ' FROM an_anagrafiche WHERE '
          + nomeCampoGiorno + ' IN (''2a'', ''2b'') '
          + ' AND FRCdiurno = ''X'' '
          + ' AND (DTSOSPESOFINOA IS NULL OR '
          + #39 + sDataSql + #39 + ' > DTSOSPESOFINOA) '
          + ' ORDER BY '
          + nomeCampoGiorno + ' ASC, '
          + ' IDORDINE ASC';
      end

      else if idV = 3 then
      begin
        sqlDinamica :=
            'SELECT ' + nomeCampoGiorno + ' AS IDV, '
          + ' DSRAGIONESOCIALE UTENTE, '
          + ' DSINDIRIZZO ||'' - ''|| DSLOCALITA ||'' - ''|| DSPROVINCIA AS INDIRIZZO, '
          + ' DSTELEFONO AS TELEFONO, DSNOTE AS NOTE '
          + ' FROM an_anagrafiche WHERE '
          + nomeCampoGiorno + ' = ''3'' '
          + ' AND FRASSPENSIONATI = ''X'' '
          + ' AND (DTSOSPESOFINOA IS NULL OR '
          + #39 + sDataSql + #39 + ' > DTSOSPESOFINOA) '
          + ' ORDER BY '
          + nomeCampoGiorno + ' ASC, '
          + ' IDORDINE ASC';
      end

      else if idV = 4 then
      begin
        sqlDinamica :=
            'SELECT ' + nomeCampoGiorno + ' AS IDV, '
          + ' DSRAGIONESOCIALE UTENTE, '
          + ' DSINDIRIZZO ||'' - ''|| DSLOCALITA ||'' - ''|| DSPROVINCIA AS INDIRIZZO, '
          + ' DSTELEFONO AS TELEFONO, DSNOTE AS NOTE '
          + ' FROM an_anagrafiche WHERE '
          + nomeCampoGiorno + ' = ''4'' '
          + ' AND FRASSPENSIONATI = ''X'' '
          + ' AND (DTSOSPESOFINOA IS NULL OR '
          + #39 + sDataSql + #39 + ' > DTSOSPESOFINOA) '
          + ' ORDER BY '
          + nomeCampoGiorno + ' ASC, '
          + ' IDORDINE ASC';
      end

      else
      begin
        sqlDinamica :=
            'SELECT ' + nomeCampoGiorno + ' AS IDV, '
          + ' DSRAGIONESOCIALE UTENTE, '
          + ' DSINDIRIZZO ||'' - ''|| DSLOCALITA ||'' - ''|| DSPROVINCIA AS INDIRIZZO, '
          + ' DSTELEFONO AS TELEFONO, DSNOTE AS NOTE '
          + ' FROM an_anagrafiche WHERE '
          + nomeCampoGiorno + ' = ' + #39 + IntToStr(idV) + #39
          + ' AND (DTSOSPESOFINOA IS NULL OR '
          + #39 + sDataSql + #39 + ' > DTSOSPESOFINOA) '
          + ' ORDER BY '
          + nomeCampoGiorno + ' ASC, '
          + ' IDORDINE ASC';
      end;

      QrySeleziona.SQL.Text := sqlDinamica;

      // Debug
      console.log('Campo giorno: ' + nomeCampoGiorno);
      console.log('SQL selezione: ' + sqlDinamica);

      await(QrySeleziona.Open);
    end;

    await(Show);
  end;
end;



procedure TFrmTrasporti.data1_change;
begin

  window.localStorage[ClassName+'_data1'] := data1.value;

  RefreshTrasporti;

end;

procedure TFrmTrasporti.data2_change;
begin

  window.localStorage[ClassName+'_data2'] := data2.value;

  RefreshTrasporti;

end;

procedure TFrmTrasporti.stampa1_click(event: TJSEvent);
var
  sql, clausola: String;
begin

  with ServerModule('TWebStampe') do
  begin
    Params['idStampa'] := '116';
    AWait(Call('WebParametri'));
    sql := Response.Strings['SQL'];
  end;

  clausola := format( 'AND IDTRASPORTO IN (%s)',[ ToCommaText(QryTrasporti,'IDTRASPORTO',true) ]);
  sql := SysUtils.StringReplace(sql,'--AND1',clausola,[]);

  with ServerModule('TWebStampe') do
  begin
    Proc := 'WebProcessa';
    Params['idStampa'] := '116';
    Params['sql'] := sql;
    Params['DATADA'] := dt1str;
    Params['DATAA'] :=  dt2str;
    window.open(Url,'_blank');
  end;

 TmRegistraEvento('stampa_trasporti',format('%s ~ %s|filtro=%s'
 ,[data1.value,data2.value,filtro.Value]));

 // TmRegistraEvento('stampa_trasporti',format('%s ~ %s|stato=%s|filtro=%s'
 //,[data1.value,data2.value,filtro.Value]));

  //idstato.value,
end;

procedure TFrmTrasporti.stampa2_click(event: TJSEvent);
var
  sql, clausola: String;
begin

  with ServerModule('TWebStampe') do
  begin
    Params['idStampa'] := '121';
    AWait(Call('WebParametri'));
    sql := Response.Strings['SQL'];
  end;

  clausola := format( 'AND IDTRASPORTO IN (%s)',[ ToCommaText(QryTrasporti,'IDTRASPORTO',true) ]);
  sql := SysUtils.StringReplace(sql,'--AND1',clausola,[]);

  with ServerModule('TWebStampe') do
  begin
    Proc := 'WebProcessa';
    Params['idStampa'] := '121';
    Params['sql'] := sql;
    Params['DATADA'] := dt1str;
    Params['DATAA'] :=  dt2str;
    window.open(Url,'_blank');
  end;

 TmRegistraEvento('stampa_trasporti',format('%s ~ %s|filtro=%s'
 ,[data1.value,data2.value,filtro.Value]));

end;

procedure TFrmTrasporti.idriepilogo_click;
var
  html: String;
begin
  // Disabilita il tasto per evitare il doppio click (causa principale di FWaitClose)
  idriepilogo.disabled := True;

  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      // CloseForm := True;  <-- Meglio toglierlo qui per evitare conflitti di stato
      QrySeleziona.Close;
      QrySeleziona.SQL.Text := 'SELECT ' +
        'LPAD(EXTRACT(DAY FROM dtdata), 2, ''0'') || ''/'' || ' +
        'LPAD(EXTRACT(MONTH FROM dtdata), 2, ''0'') || ''/'' || ' +
        'EXTRACT(YEAR FROM dtdata) || '' - '' || ' +
        'SUBSTRING(horapartenza FROM 1 FOR 5) || '' - '' || ' +
        'COALESCE(dsautista, '''') || '' - '' || ' +
        'COALESCE(dsaccompagnatore, '''') || '' - '' || ' +
        'COALESCE(dsfruitore, '''') || '' - '' || ' +
        'COALESCE(dsfruitore2, '''') AS riepilogo_trasporti '
        + ' FROM ta_trasporti '
        + ' WHERE idsocieta = ''DON001'' '
        + ' AND ' + whereDate;


      if not fltuttitrasporti.checked then
      begin
        QrySeleziona.SQL.Text := QrySeleziona.SQL.Text
          + ' AND (idautista = ' + user.QryUtenti.FieldByName('idanagrafica').AsString
          + ' OR idaccompagnatore = ' + user.QryUtenti.FieldByName('idanagrafica').AsString + ')';
      end;

      QrySeleziona.SQL.Text := QrySeleziona.SQL.Text + ' order by dtdata, dsautista, horapartenza ';
      await(QrySeleziona.Open);
    end;

    // --- MANCAVA QUESTA PARTE ---
    if await(Show) = mrOK then
    begin
      if QrySeleziona.IsEmpty then
      begin
        window.alert('Nessun record trovato.');
      end
      else
      begin
        html := '<html><body style="font-family:monospace;">';
        html := html + '<h3>Riepilogo Trasporti</h3>';

        QrySeleziona.First;
        while not QrySeleziona.Eof do
        begin
          html := html + '<div style="border-bottom:1px solid #ccc;">'
               + 'DATA: ' + QrySeleziona.FieldByName('dtdata').AsString
               + ' - ID AUTISTA: ' + QrySeleziona.FieldByName('idautista').AsString
               + '</div>';
          QrySeleziona.Next;
        end;

        html := html + '</body></html>';

        with window.open('', '_blank') do
        begin
          document.write(html);
          document.close();
        end;
      end;
    end;
    // ----------------------------
  end;

  idriepilogo.disabled := False;
end;

//procedure TFrmTrasporti.link3_click(event: TJSEvent);
//begin
//
//  if QryTrasporti.RecordCount < 1 then
//  begin
//    ShowMessage('prima di stampare devi eseguire la query...');
//    exit;
//  end;
//
//  with ServerModule('TWebStampe') do
//  begin
//    Proc := 'WebProcessa';
//    Params['idStampa'] := '89';
//    Params['sql'] := ' select * from ord_ordinimarketing '
//     + ' where mel_idsocieta = ''DON001'' '
//     + ' and ' + whereDate;
//   if idstato.value <> '' then
//   begin
//    Params['sql'] := Params['sql'] + ' and mel_dsstato = ' + '''' + idstato.value + ''''
//   end;
//  Params['sql'] := Params['sql'] + ' order by data ';
//  link3.href := Url;
//  link3.target := '_blank';
//  end;
//
//end;

function TFrmTrasporti.DateOk: Boolean;
var
  dt1, dt2: TDateTime;
begin

  Result :=  false;

  if (data1.value = '') or (data2.value = '')
    or (data1.value > data2.value) then
  begin
    SetLabel(labelTop,msgDateErrate);
    SetLabel(labelBottom,'');
    exit;
  end;

  Result :=  true;

  dt1 := ScanDateTime('yyyy-MM-dd',data1.value);
  dt2 := ScanDateTime('yyyy-MM-dd',data2.value) ;
  dt2 := IncDay(dt2);

// questo formato date serve per la query
  dt1str := FormatDateTime('dd.MM.yyyy',dt1);
  dt2str := FormatDateTime('dd.MM.yyyy',dt2);

  whereDate := ' dtdata >= ''' + dt1str + ''''
    + ' and dtdata < ''' + dt2str + '''';

// questo formato di date serve alla stampa
  dt1str := FormatDateTime('dd/MM/yyyy',dt1) + ' 00:00:00';
  dt2str := FormatDateTime('dd/MM/yyyy',dt2) + ' 00:00:00';

end;

initialization
  RegisterWeb(TFrmTrasporti);

end.

